import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@fluentui/react-components';
import { PlacementQualityToText } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import { useItemInfoVideoQualityStyles } from '../../styles';

export const VideoQualityBadge = ({
  i18n,
  quality,
}) => {
  const classes = useItemInfoVideoQualityStyles();

  const qualityText = PlacementQualityToText[quality];
  return (
    <div className={classes.contentItem}>
      <div className={classes.contentName}>{i18n.getString(_TL_('Quality:'))}</div>
      <div className={classes.contentValue}><Badge color="success" className={classes.qualityBadge}>{qualityText}</Badge></div>
    </div>
  );
};

VideoQualityBadge.propTypes = {
  quality: PropTypes.number,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

VideoQualityBadge.defaultProps = {
  quality: null,
};
